import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import LandingSearchForm from './LandingSearchForm/LandingSearchForm';
import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import css from './SectionHero.module.css';

function SectionHero(props) {
  const { history, isLandingPage } = props;

  const intl = useIntl();
  const routeConfiguration = useRouteConfiguration();
  const handleSubmit = values => {
    const { location = {}, dates, ...rest } = values;
    const { search, selectedPlace = {} } = location;
    const { bounds } = selectedPlace;
    const searchQuery = {
      address: search,
      dates,
      bounds,
      search,
      ...rest,
    };

    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchQuery));
  };

  return (
    <div className={css.heroContainer}>
      <div className={css.contentWidth}>
        <div className={css.heroContent}>
          <h1 className={css.animatedText}>
            <FormattedMessage id="LandingPage.heroTitle" />
          </h1>
          <p>
            <FormattedMessage id="LandingPage.heroDescription" />
          </p>
          <div className={css.heroSearchSec}>
            <LandingSearchForm
              rootClassName={css.landingSearchForm}
              onSubmit={handleSubmit}
              intl={intl}
              isLandingPage={isLandingPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionHero;
